import { DatePipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-grh-accident',
  templateUrl: './grh-accident.component.html',
  styleUrls: ['./grh-accident.component.scss'],
})
export class GrhAccidentComponent implements OnInit {
  exist = false;
  perso;
  //variable dialogue Employeur
  RS = null;
  nCnss = null;
  adresse = null;
  codepostal = null;
  nTel = null;
  NatActivite = null;
  //variable dialogue victim
  NumAffec = null;
  NpVic = null;
  PrPere = null;
  njFille = null;
  nat = null;
  Sexe = null;
  dateNais = null;
  LieuNai = null;
  cin = null;
  adresseDom = null;
  CodePostal = null;
  //
  dateEmb = null;
  qualifPro = null;
  Status = null;
  EmpHabit = null;
  depuis = null;

  ocupation = null;
  depuis2 = null;
  adrHabTrav = null;
  ListSoc;
  //variable tableau
  nompSous = null;
  postSous = null;
  faitA = null;
  le = null;
  //Temoins
  npa = null;
  dateTiers = null;
  poste = null;
  pv = null;
  //Tiers
  Tiers = null;
  npTiers = null;
  societe = null;
  //accid
  dateAcc;
  time;
  timedeb;
  timefin;
  timePauseDeb;
  timePauseFin;
  lieuAcc;

  ouAcci;
  autre;
  nbemp;
  dateEmbSpan;
  dateNaisSpan;
  dateLeSpan;
  dateTiersf;
  dateAccident;
  dateArretTra = null;
  dateTemoinSpan;
  dateAccidan;
  detaillAcc;
  agentMateriel;
  formeAcciden;
  siegeLes;
  natureLes;
  lieuTransp;
  heureTrans;
  arretSit;
  dateArret;
  heureArret;
  salMaint;
  salaireMAintenu;
  montant;
  par;
  autreVictime;
  isAutre = false;
  persoRech;
  paramId;
  impTop;
  api = 'https://backend-uniges.pmc.tn/api/';
  constructor(
    private generalService: GeneralService,
    private datePipe: DatePipe,
    private aroute: ActivatedRoute,
    private loc: Location
  ) {
    // this.dateArretTra=null;
    this.generalService.rechercheTable2('api_imp_top').subscribe((res) => {
      //console.log(res);
      this.impTop = res;
    });
    this.generalService.rechercheTable2('API_Soc').subscribe((res) => {
      //console.log(res);
      this.ListSoc = res;
    });
    this.aroute.paramMap.subscribe((par) => {
      this.paramId = par.get('id');
    });
    console.log(this.paramId);
    if (this.paramId) {
      this.generalService
        .getDS('Cnam_AccidentTravail', this.paramId)
        .subscribe((res) => {
          console.log(res);
          this.findSocById(res['Cnam_AccidentTravail'][0].Id_Employeur);
          this.blurPerso(res['Cnam_AccidentTravail'][0].Perso_Matricule);

          this.ocupation = res['Cnam_AccidentTravail'][0].XOccupation;
          this.datedepuis2 = res['Cnam_AccidentTravail'][0].XDepuis;
          this.adrHabTrav = res['Cnam_AccidentTravail'][0].XAdresse;
          this.autreVictime = res['Cnam_AccidentTravail'][0].XAutreVictime;
          // //Accident
          this.dateAcc = res['Cnam_AccidentTravail'][0].Date_accident;
          this.dateAccidan = this.datePipe.transform(
            this.dateAcc,
            'MM/dd/YYYY'
          );
          this.lieuAcc = res['Cnam_AccidentTravail'][0].Lieu_Accident;
          this.agentMateriel =
            res['Cnam_AccidentTravail'][0].AgentMateriel_accident;
          this.detaillAcc =
            res['Cnam_AccidentTravail'][0].Circonstances_accident;
          this.arretSit = res['Cnam_AccidentTravail'][0].Consequence;
          this.dateArretTra = res['Cnam_AccidentTravail'][0].Date_ArretTravail;
          this.ouAcci = res['Cnam_AccidentTravail'][0].Etablissement_accident;
          this.time = res['Cnam_AccidentTravail'][0].Heure_Accident;
          this.formeAcciden = res['Cnam_AccidentTravail'][0].Forme_accident;
          this.montant = res['Cnam_AccidentTravail'][0].Montant;
          this.timedeb = res['Cnam_AccidentTravail'][0].Heure_debTravail;
          this.timefin = res['Cnam_AccidentTravail'][0].Heure_finTravail;
          this.timePauseDeb = res['Cnam_AccidentTravail'][0].Heure_debTravail1;
          this.timePauseFin = res['Cnam_AccidentTravail'][0].Heure_finTravail1;
          this.heureTrans = res['Cnam_AccidentTravail'][0].Heure_transportVict;
          this.lieuTransp = res['Cnam_AccidentTravail'][0].Lieu_transportVict;
          this.natureLes = res['Cnam_AccidentTravail'][0].Nature_lesion;

          this.nbemp = res['Cnam_AccidentTravail'][0].Nbre_travailleurs;
          this.heureTrans = res['Cnam_AccidentTravail'][0].Periode_Montant;
          if (res['Cnam_AccidentTravail'][0].Salaire_maintenu == 1)
            this.salMaint = this.salaireMAintenu =
              res['Cnam_AccidentTravail'][0].Duree_miantenue;
          this.siegeLes = res['Cnam_AccidentTravail'][0].Siège_lesion;
          this.heureTrans = res['Cnam_AccidentTravail'][0].UniteDuree_miantenue;

          this.montant = res['Cnam_AccidentTravail'][0].Montant;
          this.par = res['Cnam_AccidentTravail'][0].Periode_Montant;
          //Temoins poste temoins
          this.npa = res['Cnam_AccidentTravail'][0].Info_Temoin;
          //date tiers?
          this.dateTiers = res['Cnam_AccidentTravail'][0].Date_Temoins;
          this.dateTemoinSpan = this.datePipe.transform(
            this.dateTiers,
            'MM/dd/YYYY'
          );
          this.poste = res['Cnam_AccidentTravail'][0].Poste_Temoins;
          this.pv = res['Cnam_AccidentTravail'][0].Num_PVPolice;

          //Tiers  societe
          this.Tiers = res['Cnam_AccidentTravail'][0].Tiers_existe;
          this.npTiers = res['Cnam_AccidentTravail'][0].Tiers;
          this.societe = res['Cnam_AccidentTravail'][0].SocAssurance_Tiers;

          // create done
          this.nompSous = res['Cnam_AccidentTravail'][0].NomPrenom_Soussignie;
          this.postSous = res['Cnam_AccidentTravail'][0].Poste_Soussignie;
          this.faitA = res['Cnam_AccidentTravail'][0].Ville_create;
          this.le = new Date(res['Cnam_AccidentTravail'][0].Date_Create);
          this.dateLeSpan = this.datePipe.transform(this.le, 'MM/dd/YYYY');
        });
      this.loc.go('/avt/grh/accident');
    }
  }
  ngOnInit(): void {
    this.exist = true;
  }
  findSocById(id) {
    this.ListSoc.forEach((element) => {
      if (element.SOC_ID == id) {
        console.log(element);
        this.lastIdSoc = element.SOC_ID;
        this.nCnss = element.SOC_AFFCNSS;
        this.RS = element.SOC_RS;
        this.societeName = element.SOC_RS;
        this.codepostal = element.SOC_CodePostal;
        this.nTel = element.SOC_NumTel;
        this.adresse = element.SOC_Adresse;
        this.NatActivite = element.XSoc_Activite;
      }
    });
  }
  persoSousRech;
  persoSousSelected;
  blurPersoSS(id) {
    this.generalService.getDS('perso', id).subscribe((res) => {
      this.persoSousSelected = res;
      this.nompSous =
        this.persoSousSelected.perso[0].Perso_Nom +
        ' ' +
        this.persoSousSelected.perso[0].Perso_Prenom;
      this.postSous = this.persoSousSelected.perso[0].Perso_Emploi;
    });
  }
  societ;
  prsoSelected;
  vider() {
    //perso
    this.persoRech = '';
    this.prsoSelected = null;
    this.NumAffec = null;
    this.NpVic = null;
    this.PrPere = null;
    this.njFille = null;
    this.nat = null;
    this.Sexe = null;

    this.dateNais = null;
    this.dateNaisSpan = null;
    this.LieuNai = null;
    this.cin = null;
    this.adresseDom = null;
    this.dateEmb = null;
    this.dateEmbSpan = null;
    this.qualifPro = null;
    this.Status = null;
    this.EmpHabit = null;
    this.depuis = null;
    this.datedepuis = null;
    //soc
    this.societ = null;
    this.lastIdSoc = null;
    this.nCnss = null;
    this.RS = null;
    this.codepostal = null;
    this.nTel = null;
    this.adresse = null;
    this.NatActivite = null;
    ////victime
    this.ocupation = null;
    this.datedepuis2 = null;
    this.adrHabTrav = null;
    this.autreVictime = null;
    // //Accident
    this.dateAccidan = null;
    this.lieuAcc = null;
    this.agentMateriel = null;
    this.detaillAcc = null;
    this.arretSit = null;
    this.dateArretTra = null;
    this.ouAcci = null;
    this.time = null;
    this.formeAcciden = null;
    this.montant = null;
    this.timedeb = null;
    this.timefin = null;
    this.timePauseDeb = null;
    this.timePauseFin = null;
    this.heureTrans = null;
    this.lieuTransp = null;
    this.natureLes = null;

    this.nbemp = null;
    this.heureTrans = null;
    this.salMaint = null;
    this.salaireMAintenu = null;
    this.siegeLes = null;
    this.heureTrans = null;

    this.montant = null;
    this.par = null;
    //Temoins poste temoins
    this.npa = null;
    //date tiers?
    this.dateTemoinSpan = null;
    this.poste = null;
    this.pv = null;

    //Tiers  societe
    this.Tiers = null;
    this.npTiers = null;
    this.societe = null;

    // create done
    this.nompSous = null;
    this.postSous = null;
    this.faitA = null;
    this.dateLeSpan = null;
  }
  blurPerso(event) {
    console.log(event);
    this.generalService.getDS('perso', event).subscribe((res) => {
      console.log(res);
      this.prsoSelected = res;
      this.NumAffec = this.prsoSelected.perso[0].Perso_N_CNSS;
      this.NpVic =
        this.prsoSelected.perso[0].Perso_Nom +
        ' ' +
        this.prsoSelected.perso[0].Perso_Prenom;
      this.PrPere = this.prsoSelected.perso[0].XPrenomPere;
      this.njFille = this.prsoSelected.perso[0].XNomJF;
      this.nat = this.prsoSelected.perso[0].Perso_Nationalite;
      if (this.prsoSelected.perso[0].Perso_Sex == 1) this.Sexe = 'H';
      else if (this.prsoSelected.perso[0].Perso_Sex == 2) {
        this.Sexe = 'F';
      }
      this.dateNais = new Date(this.prsoSelected.perso[0].Perso_DateNaissance);
      this.dateNaisSpan = this.datePipe.transform(this.dateNais, 'MM/dd/YYYY');
      this.LieuNai = this.prsoSelected.perso[0].XLieuNaissance;
      this.cin = this.prsoSelected.perso[0].Perso_CIN;
      this.adresseDom = this.prsoSelected.perso[0].Perso_Adresse;
      this.dateEmb = new Date(this.prsoSelected.perso[0].Perso_DateDeb);
      this.dateEmbSpan = this.datePipe.transform(this.dateEmb, 'MM/dd/YYYY');
      this.qualifPro = this.prsoSelected.perso[0].XqualProfessionel;
      this.Status = this.prsoSelected.perso[0].Perso_Status;
      this.EmpHabit = this.prsoSelected.perso[0].Perso_Emploi;
      this.depuis = new Date(this.prsoSelected.perso[0].XdateDeclaration);
      this.datedepuis = this.datePipe.transform(this.depuis, 'MM/dd/YYYY');
    });
  }

  handleChange(ev) {
    console.log(ev);
    if (ev.value == 'Autre') this.isAutre = true;
    else this.isAutre = false;

    console.log(this.isAutre);
  }
  societeName;
  lastIdSoc;
  selectSoc(soc) {
    console.log(soc);

    this.societeName = soc;
    this.ListSoc.forEach((element) => {
      if (element.SOC_RS == soc) {
        console.log(element);
        this.lastIdSoc = element.SOC_ID;
        this.nCnss = element.SOC_AFFCNSS;
        this.RS = element.SOC_RS;
        this.codepostal = element.SOC_CodePostal;
        this.nTel = element.SOC_NumTel;
        this.adresse = element.SOC_Adresse;
        this.NatActivite = element.XSoc_Activite;
      }
    });
  }
  societeId() {
    let id = null;
    this.ListSoc.forEach((element) => {
      if (element.SOC_RS == this.societeName) {
        id = element.SOC_ID;
      }
    });
    return id;
  }
  selectSexe(s: any) {
    this.Sexe = s;
    console.log(s);
  }
  selectAuv(s: any) {
    this.autreVictime = s.value;
    console.log(s);
  }
  selectConsequence(s: any) {
    this.arretSit = s;
    console.log(s);
  }
  selectsalaire(s: any) {
    this.salMaint = s;
    console.log(s);
  }
  selectTiers(s: any) {
    this.Tiers = s;
    console.log(s);
  }
  dateNaisChange() {
    this.dateNaisSpan = this.datePipe.transform(this.dateNais, 'MM/dd/YYYY');
  }
  dateTemoinChange() {
    this.dateTemoinSpan = this.datePipe.transform(this.dateTiers, 'MM/dd/YYYY');
  }
  dateAreetTrav() {
    this.dateArretTra = this.datePipe.transform(this.dateArret, 'MM/dd/YYYY');
  }
  dateAccid() {
    this.dateAccidan = this.datePipe.transform(this.dateAcc, 'MM/dd/YYYY');
  }
  // dateAccid() {
  //   this.dateArretTra = this.datePipe.transform(this.dateArret, 'dd/MM/YYYY')
  // }
  dateEmbChange() {
    this.dateEmbSpan = this.datePipe.transform(this.dateEmb, 'MM/dd/YYYY');
  }
  datedepuis;
  datedepuis2;
  depuisChange() {
    this.datedepuis = this.datePipe.transform(this.depuis, 'MM/dd/YYYY');
  }
  depuis2Change() {
    this.datedepuis2 = this.datePipe.transform(this.depuis2, 'MM/dd/YYYY');
  }
  dateLe() {
    this.dateLeSpan = this.datePipe.transform(this.le, 'MM/dd/YYYY');
  }
  dateTiersFn() {
    this.dateTiersf = this.datePipe.transform(this.dateTiers, 'MM/dd/YYYY');
  }
  enregistrer() {
    this.generalService.getDS('Cnam_AccidentTravail').subscribe(
      (res) => {
        res['Cnam_AccidentTravail'][0].Id_Employeur = this.societeId();
        res['Cnam_AccidentTravail'][0].Perso_Matricule =
          this.prsoSelected.perso[0].Perso_Matricule;

        ////victime
        res['Cnam_AccidentTravail'][0].XOccupation = this.ocupation;
        res['Cnam_AccidentTravail'][0].XDepuis = this.datedepuis2;
        res['Cnam_AccidentTravail'][0].XAdresse = this.adrHabTrav;
        res['Cnam_AccidentTravail'][0].XAutreVictime = this.autreVictime;
        // //Accident
        res['Cnam_AccidentTravail'][0].Date_accident = this.dateAccidan;
        res['Cnam_AccidentTravail'][0].Lieu_Accident = this.lieuAcc;
        res['Cnam_AccidentTravail'][0].AgentMateriel_accident =
          this.agentMateriel;
        res['Cnam_AccidentTravail'][0].Circonstances_accident = this.detaillAcc;
        res['Cnam_AccidentTravail'][0].Consequence = this.arretSit;
        res['Cnam_AccidentTravail'][0].Date_ArretTravail = this.dateArretTra;
        res['Cnam_AccidentTravail'][0].Etablissement_accident = this.ouAcci;
        res['Cnam_AccidentTravail'][0].Heure_Accident = this.time;
        res['Cnam_AccidentTravail'][0].Forme_accident = this.formeAcciden;
        res['Cnam_AccidentTravail'][0].Montant = this.montant;
        res['Cnam_AccidentTravail'][0].Heure_debTravail = this.timedeb;
        res['Cnam_AccidentTravail'][0].Heure_finTravail = this.timefin;
        res['Cnam_AccidentTravail'][0].Heure_debTravail1 = this.timePauseDeb;
        res['Cnam_AccidentTravail'][0].Heure_finTravail1 = this.timePauseFin;
        res['Cnam_AccidentTravail'][0].Heure_transportVict = this.heureTrans;
        res['Cnam_AccidentTravail'][0].Lieu_transportVict = this.lieuTransp;
        res['Cnam_AccidentTravail'][0].Nature_lesion = this.natureLes;

        res['Cnam_AccidentTravail'][0].Nbre_travailleurs = this.nbemp;
        res['Cnam_AccidentTravail'][0].Periode_Montant = this.heureTrans;
        res['Cnam_AccidentTravail'][0].Salaire_maintenu = this.salMaint;
        res['Cnam_AccidentTravail'][0].Duree_miantenue = this.salaireMAintenu;
        res['Cnam_AccidentTravail'][0].Siège_lesion = this.siegeLes;
        res['Cnam_AccidentTravail'][0].UniteDuree_miantenue = this.heureTrans;

        res['Cnam_AccidentTravail'][0].Montant = this.montant;
        res['Cnam_AccidentTravail'][0].Periode_Montant = this.par;
        //Temoins poste temoins
        res['Cnam_AccidentTravail'][0].Info_Temoin = this.npa;
        //date tiers?
        res['Cnam_AccidentTravail'][0].Date_Temoins = this.dateTemoinSpan;
        res['Cnam_AccidentTravail'][0].Poste_Temoins = this.poste;
        res['Cnam_AccidentTravail'][0].Num_PVPolice = this.pv;

        //Tiers  societe
        res['Cnam_AccidentTravail'][0].Tiers_existe = this.Tiers;
        res['Cnam_AccidentTravail'][0].Tiers = this.npTiers;
        res['Cnam_AccidentTravail'][0].SocAssurance_Tiers = this.societe;

        // create done
        res['Cnam_AccidentTravail'][0].NomPrenom_Soussignie = this.nompSous;
        res['Cnam_AccidentTravail'][0].Poste_Soussignie = this.postSous;
        res['Cnam_AccidentTravail'][0].Ville_create = this.faitA;
        res['Cnam_AccidentTravail'][0].Date_Create = this.dateLeSpan;
        console.log(res);
        if (this.formFill()) {
          this.generalService.postDs(res).subscribe(
            (resp) => {
              console.log(resp);
              this.generalService.dialogSuccess(
                'Enregistrement avec succés',
                true
              );
            },
            (err) => {
              this.generalService.dialogSuccess(
                'Une Erreur se produite',
                false
              );
            }
          );
        } else {
          this.generalService.dialogSuccess('Remplir les champ', false);
        }
      },
      (error) => {
        this.generalService.dialogSuccess('Probléme de connexion', false);
      }
    );
  }
  formFill() {
    let test = false;
    if (
      this.nompSous &&
      this.postSous &&
      this.faitA &&
      this.dateLeSpan &&
      this.Tiers
    ) {
      test = true;
    }
    return test;
  }
  imprimer() {
    console.log(this.timedeb);
    this.generalService.printContentsTest(
      'accident',
      '../../assets/print/imp_dec_at-1.jpg'
    );
  }
}
